<template>
  <div>
    <div :class="[$style.card]">
      <div :class="$style.title">
        {{ $t('settings.notifyOnUnusualBehaviorByDataCategories') }}
      </div>
      <label
        v-for="sett in settings.slice(0, -3)"
        :key="sett.stype"
        :class="$style.settContainer"
        @click="check(sett.stype)"
        @click.stop.prevent
      >
        <div :class="$style.label">
          {{ sett.description }}
        </div>
        <toggle-button
          v-model="sett.checked"
          :value="sett.checked"
          :sync="true"
          @click.native.prevent
        />
      </label>
    </div>
    <div :class="[$style.card]">
      <div :class="$style.settContainer">
        <label :class="$style.label">{{ $t('settings.timeIntervalForAnalysis') }}</label>
        <div :class="$style.inline">
          <input
            v-model.number="statPeriod"
            type="number"
            :class="$style.input"
            @change="change(sTypeParams.statPeriod, statPeriod)"
          >
          <div :class="$style.measure">
            {{ $t('global.workingDays') }}
          </div>
        </div>
      </div>
      <div
        v-for="sett in settings.slice(-3)"
        :key="sett.stype"
      >
        <label
          :class="$style.settContainer"
          @click="check(sett.stype)"
          @click.stop.prevent
        >
          <div :class="$style.label">
            <span>{{ sett.description }}</span>
            <input
              v-if="sett.stype === sTypeParams.increasedCPU"
              v-model.number="consCPU"
              type="number"
              :class="[$style.input, $style.inputCPU]"
              @change="change(sTypeParams.consCPU, consCPU)"
              @click.stop
            >
            <span
              v-if="sett.stype === sTypeParams.increasedCPU"
              :class="$style.measure"
            >
              %
            </span>
          </div>
          <toggle-button
            v-model="sett.checked"
            :value="sett.checked"
            :sync="true"
            @click.native.prevent
          />
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  import { ToggleButton } from 'vue-js-toggle-button';
  import Vue from 'vue';
  import { getAcselParams } from '@/api/methods/settings';
  import { S_TYPE_PARAMS } from '@/views/settings/const';

  Vue.component('ToggleButton', ToggleButton);

  export default {
    data() {
      return {
        settings: [
          {
            description: this.$t('settings.settings.printingDocuments'),
            stype: 31,
            checked: false,
            val: 0,
            sval: '',
          },
          {
            description: this.$t('settings.settings.visitingWebsites'),
            stype: 32,
            checked: false,
            val: 0,
            sval: '',
          },
          {
            description: this.$t('settings.settings.uploadingFilesToInternet'),
            stype: 33,
            checked: false,
            val: 0,
            sval: '',
          },
          {
            description: this.$t('settings.settings.copyingFilesToRemovableDrives'),
            stype: 34,
            checked: false,
            val: 0,
            sval: '',
          },
          {
            description: this.$t('settings.settings.messagingInMessengers'),
            stype: 35,
            checked: false,
            val: 0,
            sval: '',
          },
          {
            description: this.$t('settings.settings.messagingInSkype'),
            stype: 36,
            checked: false,
            val: 0,
            sval: '',
          },
          {
            description: this.$t('settings.settings.messagingInSocialNetworks'),
            stype: 37,
            checked: false,
            val: 0,
            sval: '',
          },
          {
            description: this.$t('settings.settings.emailCorrespondence'),
            stype: 38,
            checked: false,
            val: 0,
            sval: '',
          },
          {
            description: this.$t('settings.settings.webEmailCorrespondence'),
            stype: 39,
            checked: false,
            val: 0,
            sval: '',
          },
          {
            description: this.$t('settings.settings.searchQueries'),
            stype: 40,
            checked: false,
            val: 0,
            sval: '',
          },
          {
            description: this.$t('settings.settings.programLaunches'),
            stype: 41,
            checked: false,
            val: 0,
            sval: '',
          },
          {
            description: this.$t('settings.settings.compareRelativeToEmployee'),
            stype: 42,
            checked: false,
            val: 0,
            sval: '',
          },
          {
            description: this.$t('settings.settings.compareRelativeToGroup'),
            stype: 43,
            checked: false,
            val: 0,
            sval: '',
          },
          {
            description: this.$t('settings.settings.increasedCPUConsumptionPerDay'),
            stype: 44,
            checked: false,
            val: 0,
            sval: '',
          },
        ],
        result: {},
        statPeriod: 10,
        consCPU: 0,
      };
    },
    computed: {
      sTypeParams() {
        return {
          statPeriod: S_TYPE_PARAMS.STAT_PERIOD,
          increasedCPU: S_TYPE_PARAMS.INCREASED_CPU,
          consCPU: S_TYPE_PARAMS.CONS_CPU,
        };
      },
      selectedComputer() {
        return {
          type: this.$route.params.type,
          id: this.$route.params.computer,
        };
      },
    },
    async created() {
      await this.getSettings();
    },
    async mounted() {
      this.$store.subscribeAction({
        // eslint-disable-next-line
        after: async (action, state) => {
          if (action.type === 'settings/cancel') {
            await this.getSettings();
          }
        },
      });
      this.$store.subscribeAction({
        // eslint-disable-next-line
        after: async (action, state) => {
          if (action.type === 'settings/paramChanged') {
            await this.getSettings();
          }
        },
      });
    },
    methods: {
      check(stype) {
        const indexOfObject = this.settings.findIndex((object) => object.stype === stype);
        this.$set(this.settings[indexOfObject], 'checked', !this.settings[indexOfObject].checked);

        if (stype === S_TYPE_PARAMS.RELATIVE_TO_EMPLOYEE || stype === S_TYPE_PARAMS.RELATIVE_TO_GROUP) {
          const compareSelf = this.settings.findIndex((object) => object.stype === S_TYPE_PARAMS.RELATIVE_TO_EMPLOYEE);
          const compareOthers = this.settings.findIndex((object) => object.stype === S_TYPE_PARAMS.RELATIVE_TO_GROUP);
          if (!this.settings[compareSelf].checked && !this.settings[compareOthers].checked) {
            this.$set(this.settings[compareSelf], 'checked', true);
          }
        }

        this.$store.commit('settings/addAcsel', this.settings[indexOfObject]);
      },
      change(stype, val) {
        this.$store.commit('settings/addAcsel', {
          stype,
          val,
          sval: '',
          checked: true,
        });
      },
      async getSettings() {
        this.result = {};
        if (this.selectedComputer.id) {
          this.promise = await getAcselParams(this.selectedComputer.id, this.selectedComputer.type).then(({ data }) => {
            if (data) {
              this.result = data.result;
              const settings = this.settings.slice();
              settings.forEach((item) => {
                const found = this.result.find((sett) => sett.stype === item.stype);
                if (found) {
                  item.checked = true;
                  item.val = found.val;
                  item.sval = found.sval;
                }
              });
              const days = this.result.find((sett) => sett.stype === S_TYPE_PARAMS.STAT_PERIOD);
              if (days) this.statPeriod = days.val;
              const consCPU = this.result.find((sett) => sett.stype === S_TYPE_PARAMS.CONS_CPU);
              if (consCPU) this.consCPU = consCPU.val;
              this.settings = settings;
            }
          });
        }
      },
    },
  };
</script>

<style lang="scss" module>
  .settContainer {
    display: flex;
    padding: 10px;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    &:hover {
      background: $light-gray;
    }
  }

  .label {
    margin: 0px 10px;
    font-size: 14px;
  }

  .input {
    margin-right: 5px;
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-radius: 4px;
    height: 30px;
    width: 90px;
  }

  .inputCPU {
    width: 50px;
    margin: 0 10px;
  }

  .card {
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    margin: 5px 0px 15px 22px;
    width: 92%;
    padding: 5px;
    > :not(:last-child) {
      border-bottom: 0.2px solid #eee;
    }
  }

  .disabled,
  .disabled * {
    cursor: default;
  }

  .inline {
    display: inline-flex;
    align-items: center;
  }

  .select {
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-radius: 4px;
    height: 30px;
    width: 230px;
    cursor: pointer;
  }

  .title {
    margin: 20px 20px 10px 20px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    border: 0px !important;
  }

  .measure {
    font-size: 14px;
  }
</style>
